export const getHiddenWriterLabel = (writerId, withRolePrefix = true) => {
  if (!writerId) return null;
  return `${withRolePrefix ? 'Freelancer ' : ''}(${writerId.slice(-4).toUpperCase()})`;
};